import { UUID } from 'symbols';

export enum TypeService {
  GUARANTEE = 'guarantee',
  SERVICE = 'service',
  AFTER_GUARANTEE = 'after_guarantee',
}

export const TYPE_SERVICE_RELATED_NAMES = {
  [TypeService.GUARANTEE]: 'Гарантія',
  [TypeService.SERVICE]: 'Сервіс',
  [TypeService.AFTER_GUARANTEE]: 'Післягарантійний'
};

export interface TypeServiceModel {
  id: UUID;
  type: TypeService;
}
